import React from 'react'
import styled from 'styled-components'

// images
import FillStarImg from '../../../assets/image/star/ic-fill-star.svg'
import EmptyStarImg from '../../../assets/image/star/ic-empty-star.svg'

function Rating({ score, isScore }) {
  const storeStarCount = Math.round(score)

  return score ? (
    <StarWrapper>
      {isScore && <TextStar>{score}</TextStar>}

      <PrintStar isScore={isScore}>
        {Array.from(Array(5).keys()).map((ele, idx) => (
          <img
            key={idx}
            src={storeStarCount >= idx + 1 ? FillStarImg : EmptyStarImg}
          />
        ))}
      </PrintStar>
    </StarWrapper>
  ) : null
}

export default Rating

const StarWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`

const TextStar = styled.div`
  color: black;
  font-size: 24px;
`

const PrintStar = styled.div`
  margin-left: ${(props) => (props.isScore ? '20px' : '0px')};
  flex: 1;
  display: flex;
  justify-content: space-evenly;

  img {
    width: 15px;
    height: 15px;
    margin-right: 3px;
  }
`
